import { statusColor } from "../lib/utils-format";

export function StatusBadge({ value, label }) {
  if (value === undefined || value === null || value === "") return <span className="text-muted-foreground">—</span>;
  const raw = typeof value === "boolean" ? (value ? "Yes" : "No") : String(value);
  // Display-only relabel: the "Preliminary Review" pipeline stage shows as "Analyze"
  // (stored value stays "Preliminary Review" so existing records aren't orphaned).
  const display = label || (raw === "Preliminary Review" ? "Analyze" : raw);
  return (
    <span
      className={`inline-flex items-center rounded-full border px-2.5 py-0.5 text-xs font-medium ${statusColor(raw)}`}
      data-testid={`badge-${raw.toLowerCase().replace(/\s+/g, "-")}`}
    >
      {display}
    </span>
  );
}
